export const dynamic = "force-dynamic";
import Link from "next/link";
import React from "react";
import { Metadata } from "next";
import urls from "@/utils/urls/urls";
// import getNotNull from '@/utils/filters/getNotNull';

export const metadata: Metadata = {
  title: "TEX EXCELLENCE LIMITED",
  description: "TEX EXCELLENCE LIMITED",
};

const ProductDetailsPage = async ({
  params,
}: {
  params: Promise<{ productId: string }>;
}) => {
  // console.log("params?.productId", params?.productId);

  const res = await fetch(urls?.productOne + "/" + (await params).productId);
  const data = await res.json();

  const product = data?.data || {};

  const product_features = product?.features.filter(
    (pd: any) => pd?.value !== "",
  );
  const product_features_optional = product?.features_optional.filter(
    (pd: any) => pd?.value !== "",
  );
  // const product_models = product?.product_model.filter(pd => pd?.value !== "")

  // console.log(product_features)
  // console.log(product_features_optional)

  // console.log("product", product);

  return (
    <div className="bg-white">
      {/* preloader */}

      {/* preloader end */}
      {/* header area */}
      {/* header area end */}
      {/* popup search */}
      {/* popup search end */}
      {/* sidebar-popup */}
      {/* sidebar-popup end */}
      <main className="main">
        {/* breadcrumb */}
        <div
          className="site-breadcrumb"
          style={{ background: "url(../assets/img/breadcrumb/01.jpg)" }}
        >
          <div className="container">
            <h2 className="breadcrumb-title">Product Details</h2>
            <ul className="breadcrumb-menu">
              <li>
                <Link href="/">Home</Link>
              </li>
              <li className="active">Product Details</li>
            </ul>
          </div>
        </div>

        {/* breadcrumb end */}
        {/* portfolio single */}
        <div className="portfolio-single py-120">
          <div className="container">
            <div className="portfolio-single-wrap">
              <div className="row">
                <div className="col-xl-4 col-lg-4">
                  <div className="portfolio-sidebar">
                    {/* <div className="widget">
                                            <h4 className="title">Product Info</h4>
                                            <ul className="list">
                                                <li>
                                                    Category <span>Solar Energy Install</span>
                                                </li>
                                                <li>
                                                    Date <span>23 Aug, 2024</span>
                                                </li>
                                                <li>
                                                    Client Name <span>Roger Collins</span>
                                                </li>
                                                <li>
                                                    Budget <span>$1250.00</span>
                                                </li>
                                                <li>
                                                    Project Manager <span>Doseph Brehmer</span>
                                                </li>
                                                <li>
                                                    Location <span>New York, USA</span>
                                                </li>
                                                <li>
                                                    Website <span>example.com</span>
                                                </li>
                                                <li>
                                                    Rating
                                                    <div className="rating">
                                                        <a href="#">
                                                            <i className="fas fa-star" />
                                                        </a>
                                                        <a href="#">
                                                            <i className="fas fa-star" />
                                                        </a>
                                                        <a href="#">
                                                            <i className="fas fa-star" />
                                                        </a>
                                                        <a href="#">
                                                            <i className="fas fa-star" />
                                                        </a>
                                                        <a href="#">
                                                            <i className="fas fa-star" />
                                                        </a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div> */}
                    {/* <div className="widget project">
                                            <h4>We Are Providing Logistic and Transport Services.</h4>
                                            <Link href="/contact" className="theme-btn2">
                                                Contact Now
                                                <i className="fas fa-arrow-right" />
                                            </Link>
                                        </div> */}
                  </div>
                </div>
                {/* <div className="col-xl-8 col-lg-8"> */}
                <div className="col-xl-12 col-lg-12">
                  <div className="portfolio-details d-flex ">
                    <div className="mb-30 col-lg-4">
                      <img src={urls.image + product?.image} alt="thumb" />
                      {/* <img src="../assets/img/portfolio/jersey.png" alt="thumb" /> */}
                    </div>
                    <div className="content col-lg-8 ml-0">
                      <h3 className="mb-20">{product?.name}</h3>
                      <div className="mb-20 ml-0">
                        {product?.description && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: product?.description,
                            }}
                          />
                        )}
                        {/* // The high speed, high production jersey machines are ideal for producing the finest quality single-knit fabrics. The computer-designed, closed cam track system ensures positive needle control and provides super stitch definition. The jersey machine is equipped with angular sinker technology to improve fabric quality and lower the defect rate, even at the highest speeds. */}
                      </div>
                      {/* <p className="mb-20">
                                                But I must explain to you how all this mistaken idea of
                                                denouncing pleasure and praising pain was born and I will
                                                give you a complete account of the system, and expound the
                                                actual teachings of the great explorer of the truth, the
                                                master-builder of human happiness. No one rejects, dislikes,
                                                or avoids pleasure itself, because it is pleasure, but
                                                because those who do not know how to pursue pleasure
                                                rationally encounter consequences that are extremely
                                                painful. Nor again is there anyone who loves or pursues or
                                                desires to obtain pain of itself, because it is pain, but
                                                because occasionally circumstances occur in which toil and
                                                pain can procure him some great pleasure. To take a trivial
                                                example
                                            </p> */}
                      {/* <div className="row">
                                                <div className="col-md-6 mb-20">
                                                    <img src="assets/img/portfolio/01.jpg" alt="" />
                                                </div>
                                                <div className="col-md-6 mb-20">
                                                    <img src="assets/img/portfolio/02.jpg" alt="" />
                                                </div>
                                            </div> */}
                      {/* <p className="mb-20">
                                                Power of choice is untrammelled and when nothing prevents
                                                our being able to do what we like best, every pleasure is to
                                                be welcomed and every pain avoided. But in certain
                                                circumstances and owing to the claims of duty or the
                                                obligations of business it will frequently occur that
                                                pleasures have to be repudiated and annoyances accepted. The
                                                wise man therefore always holds in these matters to this
                                                principle of selection.
                                            </p> */}
                      {product_features?.length > 0 ? (
                        <div className="my-4">
                          <div className="mb-3">
                            <h3 className="mb-3">Features</h3>
                          </div>
                          <ul className="list">
                            {product?.features?.map(
                              (feat: any, index: number) => (
                                <li key={index}>
                                  <i className="far fa-check-double" />
                                  {feat.value}
                                  {/* Four-track capable, which includes one set of high-speed jersey cams */}
                                </li>
                              ),
                            )}
                          </ul>
                        </div>
                      ) : (
                        <></>
                      )}

                      {product_features_optional?.length > 0 ? (
                        <div className="my-4">
                          <div className="mb-3">
                            <h3 className="mb-3">Optional Features</h3>
                          </div>
                          <ul className="list">
                            {product?.features_optional?.map(
                              (feat: any, index: number) => (
                                <li key={index}>
                                  <i className="far fa-check-double" />
                                  {feat.value}
                                  {/* Four-track capable, which includes one set of high-speed jersey cams */}
                                </li>
                              ),
                            )}
                          </ul>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* portfolio single end */}
        {product?.product_model.length > 0 ? (
          <div>
            <table>
              <thead>
                <tr>
                  <th>Model</th>
                  <th>Feeds Per Inch</th>
                  <th>Sinker Top</th>
                  <th>Gauge</th>
                  <th>Diameter Range</th>
                  <th>Speed Factor</th>
                </tr>
              </thead>
              <tbody>
                {product?.product_model?.map((feat: any, index: number) => (
                  <tr key={index}>
                    <td>{feat?.model_name}</td>
                    <td>{feat?.feeds_per_inch}</td>
                    <td>{feat?.sinker_top}</td>
                    <td>{feat?.gauge}</td>
                    <td>{feat?.diameter_range}</td>
                    <td>{feat?.speed_factor}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <></>
        )}
      </main>
      {/* footer area */}
      {/* scroll-top */}
      <a href="#" id="scroll-top">
        <i className="far fa-arrow-up" />
      </a>
      {/* scroll-top end */}
      {/* js */}
    </div>
  );
};

// export const getServerSideProps = async ({ params }: { params: { productId: any } }) => {
//     const res = await fetch(urls.product + params.productId);
//     const product = await res.json();

//     return {
//       props: {
//         product,
//       },
//     };
//   };

export default ProductDetailsPage;
